import css from 'styled-jsx/css';

const styles = css.global`#instalacao {
  position: relative;
  margin-top: 5px;
  margin-bottom: 14px;
  background-color: #cc0000;
  box-shadow: 0px 4px 4px 0px #00000040;
  padding-top: 96px;
  padding-bottom: 81px;
  z-index: 1;
}

#instalacao .conteudo {
  position: relative;
  display: flex;
  flex-direction: column-reverse;
  align-items: stretch;
  justify-content: center;
  width: 100%;
  gap: 47px;
}

#instalacao h3 {
  margin: 0;
  font-weight: 900;
  font-family: 'SantanderHeadline';
  font-size: 24px;
  line-height: 36px;
  color: #fff;
  margin-bottom: 24px;
  text-align: left;
}

#instalacao .recomendacoes {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 50px;
  width: 100%;
}

#instalacao .recomendacoes-card-2,
#instalacao .recomendacoes-card {
  position: relative;
  background-color: #ffffff;
  border: 3px solid #ffffff;
  box-shadow: 0px 2px 8px 0px #22222266;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  gap: 24px;
}

#instalacao .recomendacoes-card {
  padding: 46px;
}

#instalacao .recomendacoes-card-2 {
  padding: 46px 25px 38px 6px;
}

#instalacao .rec-title {
  margin: 0;
  position: absolute;
  top: -27px;
  left: calc(50% - 100px);
  font-family: SantanderHeadline;
  font-size: 24px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0px;
  text-align: center;
  color: #ffffff;
  background-color: #990000;
  border-radius: 2px;
  width: 200px;
  padding: 12px 0;
}

.steps-card {
  width: 160px;
  height: 160px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 12px 6px 12px 12px;
  box-shadow: 0px 2px 8px 0px #22222266;
  border-radius: 5px;
  color: #cc0000;
}

.step-title {
  display: flex;
  gap: 8px;
  width: 100%;
}

#instalacao .recomendacoes .steps-card h4 {
  font-family: SantanderHeadline;
  font-size: 18px;
  font-weight: 900;
  line-height: 26px;
  letter-spacing: 0em;
  text-align: left;
}

#instalacao .recomendacoes .steps-card p {
  font-family: SantanderText;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0em;
  text-align: left;
}

#instalacao .recomendacoes ul {
  display: flex;
  flex-direction: column;
  gap: 24px;
  list-style: disc;
  padding-left: 24px;
  font-family: SantanderText;
  font-size: 18px;
  font-weight: 400;
  line-height: 28px;
  letter-spacing: 0px;
  text-align: left;
  color: #000000;
}

#instalacao .recomendacoes b {
  color: #cc0000;
  font-weight: 500;
}

#instalacao .car-wrapper {
  position: relative;
  overflow: visible;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  z-index: 1;
}

#instalacao .car-wrapper picture {
  display: flex;
  position: relative;
}

#instalacao .car-wrapper .car-2 {
  z-index: 2;
  transform: translate(-34px, -6px);
}

#instalacao .logo-sntd {
  display: none;
}

#instalacao .form {
  border: 1px solid #767676;
  border-radius: 5px 0px 0px 5px;
  box-shadow: 0px 4px 4px 0px #00000040;
  background-color: #ffffff;
  width: 100%;
  margin: 0 auto;
  padding: 17px;
}

#instalacao .form h3 {
  color: #000000;
  line-height: 28px;
  font-weight: 400;
  margin-top: 16px;
  margin-bottom: 24px;
  font-size: 18px;
  max-width: 268px;
  text-align: center;
}

#instalacao .form h3 b {
  color: #cc0000;
  font-weight: 800;
}

#instalacao .form h4 {
  font-family: 'SantanderText';
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  margin-bottom: 8px;
  margin-top: 16px;

  color: #000000;
}

#instalacao .titulo-steps p{
  font-family: 'SantanderText';
  font-size: 18px;
  line-height: 28px;
  font-weight: 400;
  color: #222222;
  margin-bottom: 10px;
  display: none;
}

#instalacao .titulo-steps p.active {
  display: block;
}

#instalacao .texto-steps p {
  font-family: 'SantanderMicroText';
  font-size: 12px;
  line-height: 16px;
  font-weight: 300;
  color: #A2A2A2;
  display: none;
}

#instalacao .texto-steps p.active {
  display: block;
}

#instalacao .steps {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 10px;
  gap: 8px;
}

#instalacao .steps span {
  display: block;
  background-color: #c4c4c4;
  height: 4px;
  flex: 1;
  border-radius: 5px;
  transition: 0.2s ease-in;
}

#instalacao .steps span.active {
  background-color: #cc0000;
}

#instalacao .form .disclaimer-form {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 24px;
  margin-top: 20px;
}

#instalacao .form .disclaimer-form p {
  font-family: 'SantanderMicroText';
  font-weight: 300;
  font-size: 12px;
  line-height: 22px;
  margin-left: 8px;
  color: #444444;
  max-width: 234px;
}

#instalacao .form .form-actions {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
  margin-top: 24px;
}

#instalacao .form .form-actions.one-button {
  justify-content: center;
}

#instalacao .form .form-actions button {
  background: none;
  border: none;
  outline: none;
  cursor: pointer;
  width: 104px;
  height: 40px;
  text-align: center;
  font-family: 'SantanderHeadline';
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  border-radius: 5px;
  padding: 0;
}

#instalacao .form .form-actions button.back {
  color: #ec0000;
  border: 1px solid #ec0000;
}

#instalacao .form .form-actions button.next {
  color: #fff;
  background-color: #ec0000;
}
#instalacao .form .disclaimer-install p {
  font-family: 'SantanderMicroText';
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;

  max-width: 288px;

  color: #444444;

  margin-bottom: 24px;
}

@media (min-width: 768px) {
  #instalacao .conteudo {
    gap: 8px;
  }
}

@media (min-width: 992px) {
  #instalacao {
    margin-top: -80px;
    margin-bottom: 81px;
  }

  #instalacao .conteudo {
    flex-direction: row-reverse;
    align-items: stretch;
    justify-content: space-between;
    /* max-width: 1238px; */
    min-height: 842px;
    margin: 0 auto;
    gap: 4px;
  }

  #instalacao .ctn {
    padding: 0;
  }

  #instalacao .logo-sntd {
    position: absolute;
    right: 8%;
    top: -99px;
    z-index: 1;
    display: flex;
    height: 1000px;
    max-width: 1000px;
    width: 100%;
  }

  #instalacao .recomendacoes {
    max-width: 620px;
  }

  #instalacao .form {
    background: #ffffff;
    border: 1px solid #767676;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 5px 0px 0px 5px;
    max-width: 543px;
    width: 100%;
    flex: 1;
    padding: 0 32px;
    box-sizing: border-box;
    margin: 0;
    padding: 24px 40px;
  }

  #instalacao h3 {
    font-size: 32px;
    line-height: 36px;
  }

  #instalacao .form h3 {
    font-size: 24px;
    line-height: 36px;
    margin-top: 0;
    max-width: 100%;
    margin-bottom: 5px;
  }

  #instalacao .steps {
    gap: 16px;
  }

  #instalacao .steps span {
    height: 6px;
  }

  #instalacao .form h4 {
    font-size: 20px;
    line-height: 29px;
    margin-top: 24px;
    margin-bottom: 16px;
  }

  #instalacao .form .form-actions button {
    font-size: 18px;
    line-height: 26px;

    width: 138px;
    height: 54px;
  }

  #instalacao .rec-title {
    width: 458px;
    left: calc(50% - 229px);
  }

  #instalacao .recomendacoes-card {
    flex-direction: row;
    gap: 24px;
  }

  #instalacao .recomendacoes-card-2 {
    padding: 46px 34px 46px 31px;
  }

  #instalacao .car-wrapper {
    overflow: hidden;
    align-items: center;
    justify-content: center;
    width: 100%;
    flex: 1;
    padding: 0;
    position: relative;
    max-width: unset;
    display: block;
  }

  #instalacao .car-wrapper .car-1 {
    left: 0;
    bottom: 0;
    transform: translate(-35px, -12px);
  }

  #instalacao .car-wrapper .car-2 {
    right: 0;
    bottom: 0;
    transform: translate(-30px, -34px);
  }

  #instalacao .logo-sntd {
    align-items: center;
    justify-content: center;
    z-index: 0;
  }

  #instalacao .form .disclaimer-form p {
    font-size: 14px;
    line-height: 22px;
    max-width: 100%;
  }

  #instalacao .form .disclaimer-install p {
    font-size: 16px;
    line-height: 22px;
    margin-bottom: 24px;
    margin-top: 24px;
    max-width: 348px;
  }
}

@media (min-width: 1080px) {
  #instalacao .conteudo {
    gap: 40px;
  }
}

@media (min-width: 1400px) {
  #instalacao {
    margin-top: -40px;
  }
}
`;

export default styles;